<template>
  <div>
    <b-table
      :data="_list"
      icon-pack="fas"

      class="border-blue-lighter text-xs measurements"
      bordered
      narrowed
      striped
      detailed
      detail-key="id"
      :opened-detailed="openedDetailedIds"
      :has-detailed-visible="row => row.children_count > 0"
      :loading="loadingData"
      
      @details-open="onDetailed"
      @details-close="onDetailsClose"
    >

      <!-- <template v-slot:empty="">
        <h4 v-if="!loadingData">{{ $t('no_rows') }}</h4>
      </template> -->

      <template>

        <b-table-column field="type" :label="$t('type')" sortable v-slot="items">
          <!-- en recursos distinguimos si es subrecurso -->
          {{ deph > 0 && items.row.type == 'resource' ? $t('subresource') : $t(items.row.type) }}
        </b-table-column>

        <b-table-column field="description" :label="$t('name')" sortable v-slot="items">
          <span v-if="items.row.status == 1">
            <b-tooltip :label="$t('pending_validation_quantity')" position="is-left">
              <b-icon class="text-orange" pack="fas" icon="question"></b-icon>
            </b-tooltip>
          </span>
          <span v-else-if="items.row.status == 2">
            <b-tooltip :label="$t('rejected')" position="is-left">
              <b-icon class="text-red" pack="fas" icon="exclamation"></b-icon>
            </b-tooltip>
          </span>
          <span @click="onClickEdit(items.row)">
            <i v-if="items.row.type === 'chapter' && items.row.level" :style="'margin-left: ' + items.row.marginLeft + 'px'" class="w-4 line-level"></i>
            {{ (items.row.type === 'chapter' ? (items.row.code + ' ') : '') + items.row.description }}
          </span>
        </b-table-column>

        <b-table-column field="unit_name" :label="$t('measurement_unit_short')" sortable v-slot="items">
          <span v-if="items.row.unit_name || items.row.type === 'chapter'">{{  items.row.type !== 'chapter' ? items.row.unit_name : project.currency  }}</span>
          <span v-else>---</span>
        </b-table-column>

        <b-table-column field="total" :label="$t('total_quantity')" centered sortable v-slot="items">
          <!-- a ejecutar -->
          <span v-if="!isTask(items.row)">{{ twoDecimals(items.row.total) }}</span>
          <span v-else>
            {{ twoDecimals(items.row.weight) }}
          </span>
          <b-icon v-if="items.row.type=='certifier' && entityBlockedAssignments"
              pack="fas"
              icon="check-double"
              type="is-success"
              size="is-small">
          </b-icon>
        </b-table-column>

        <b-table-column field="executed_quantity" :label="executedQuantityLabel" centered sortable v-slot="items">
          <!-- inspected  -->
          <span >{{ twoDecimals(items.row.executed_quantity) }} 
            {{ isTask(items.row)? '%' : ''}}
          </span>
        </b-table-column>
 
        <b-table-column field="pending_validation_quantity" :label="pendingQuantityLabel" centered sortable v-slot="items">
          <!-- pending inspect  -->
          <span v-if="isResource(items.row) || isTask(items.row)">
            {{ twoDecimals(items.row.pending_validation_quantity) }}
            <span v-if="items.row.pending_validation_quantity != 0 &&
                  !items.row.has_children && apiProject.can_validate"
                @click="onClickValidate(items.row)">
              <b-tooltip
                :label="$t('validate')"
                position="is-top"
              >
                  <b-icon pack="fas" icon="thumbs-up"></b-icon>
              </b-tooltip>
            </span>
          </span>
          <span v-else>---</span>
        </b-table-column>

        <b-table-column field="progress_label" :label="progressLabelShort" centered sortable v-slot="items">
          <progress-bar
            v-if="!isTask(items.row) && items.row.total > 0"
            :step="parseFloat((items.row.executed_quantity * 100) / items.row.total)"
            color="blue-light"
            class="w-full"
          />
          <progress-bar
            v-else
            :step="parseFloat(items.row.executed_quantity || 0)"
            color="blue-light"
            class="w-full"
          />
        </b-table-column>

        <b-table-column v-if="project.can_progress" 
          field="actual_progress" :label="$t('actual_quantity')" centered sortable v-slot="items">
          <!-- real  -->
          <span>{{ twoDecimals(items.row.actual_progress) }}
            {{ isTask(items.row)? '%' : '' }}
          </span>
        </b-table-column>
        <!-- pendig real only task -->
        <b-table-column v-if="project.can_progress"
          field="actual_pending" :label="$t('actual_pending')" centered sortable v-slot="items">
          <span>
            {{ isTask(items.row) ? twoDecimals(100 - parseFloat(items.row.actual_progress || 0)) : '--' }}
            {{ isTask(items.row)? '%' : '' }}
          </span>
        </b-table-column>

        <b-table-column v-if="project.can_progress" field="progress_label" :label="$t('actual_progress_short')" centered sortable v-slot="items">
          <progress-bar
            v-if="!isTask(items.row) && items.row.total > 0"
            :step="parseFloat((  (items.row.actual_progress || 0 ) * 100) / items.row.total)"
            color="blue-light"
            class="w-full"
          />
          <progress-bar
            v-else-if="items.row.weight > 0"
            :step="parseFloat(items.row.actual_progress || 0)"
            color="blue-light"
            class="w-full"
          />
        </b-table-column>

        <b-table-column field="completed" :label="$t('activity_status_done')" centered sortable v-slot="items">
          <b-tooltip
            :label="items.row.completed ? $t('completed'):$t('uncompleted')"
            position="is-top"
          >
            <div v-html="isCompleted(items.row)"></div>
          </b-tooltip>
        </b-table-column>
        <b-table-column v-if="project.can_progress"
        field="completed" :label="$t('actual_completed')" centered sortable v-slot="items">
          <b-tooltip
            :label="items.row.completed ? $t('completed'):$t('uncompleted')"
            position="is-top"
          >
            <div v-html="isCompleted(items.row, true)"></div>
          </b-tooltip>
        </b-table-column>

        <b-table-column v-if="company && company.configs && company.configs.subtasks"
          field="issue_status" :label="$t('task_status')" cell-class="vertical-center" centered sortable v-slot="items">
          <div v-if="getIssueIcon(items.row) != null" class="flex text-center align-middle justify-center">
            <b-tooltip class="text-center" :label="$t('issues')" position="is-left">
              <b-icon v-if="getIssueIcon(items.row).icon != 'hand'"
                :icon="getIssueIcon(items.row).icon" pack="fas" size="is-small" :class="getIssueIcon(items.row).color"></b-icon>
              <!-- si es hand usamos la imagen -->
              <img v-else :src="asset('public/westop-tke.png')" alt="Expanded Image" width="28" class="p-1" />
            </b-tooltip>
          </div>
        </b-table-column>

        <b-table-column field="assignment_context_menu" label="" cell-class="w-8 vertical-center" centered v-slot="items">
          <template v-if="showAssignmentActionsMenu(items.row)">
            <div class="text-center cursor-pointer" @click.stop>
              <b-dropdown aria-role="list" position="is-bottom-left">
                <template #trigger="{ active }">
                  <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                </template>
                <b-dropdown-item
                  aria-role="listitem"
                  @click="openEditAssignmentModal(items.row)"
                  :disabled="!canEditAssignment(items.row)"
                >
                  <span class="text-xs">{{ $t('edit') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  @click="openTraceabilityModal(items.row)"
                >
                  <span class="text-xs">
                    {{ $t('show_traceability_lines') }}
                    <span
                      v-if="items.row.lines && items.row.lines.length"
                      class="ml-1 font-semibold text-blue"
                    >({{ items.row.lines.length }})</span>
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="isTask(items.row) && isLockAssignmentTask(items.row) == false"
                  @click="onCommentChanged(items.row)"
                >
                  <span class="text-xs">{{ $t('add_comment_document') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isResource(items.row) && items.row.children_count == 0 && canRecordActualprogress"
                  @click="openContributeDrawingModal(items.row, true)"
                >
                  <span class="text-xs">{{ $t('actual_progress') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isResource(items.row) && items.row.children_count == 0"
                  @click="openContributeDrawingModal(items.row, false)"
                >
                  <span class="text-xs">{{ registerProgressLabel }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isResource(items.row) && items.row.lines == null"
                  @click="addSubResource(items.row)"
                  :disabled="!canEditAssignmentsLock()"
                >
                  <span class="text-xs">{{ $t('add_subresource') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isTask(items.row) && items.row.children_count == 0 && isLockAssignmentTask(items.row) == false"
                  @click="onRegisterTask(items.row, false)"
                >
                  <span class="text-xs font-medium text-green">{{ $t('register_inspect') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isTask(items.row) && items.row.children_count == 0 && project.can_progress && isLockAssignmentTask(items.row) == false"
                  @click="onRegisterTask(items.row, true)"
                >
                  <span class="text-xs font-medium text-green">{{ $t('register_real') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isTask(items.row) && canManage && withSubTasks() && isLockAssignmentTask(items.row) == false"
                  @click="onCreateTaskSubTask(items.row)"
                >
                  <span class="text-xs text-blue">{{ $t('add_subtask') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isTask(items.row) && company && company.configs && company.configs.subtasks && isLockAssignmentTask(items.row) == false"
                  @click="onRegisterTask(items.row, false, 2)"
                >
                  <span class="text-xs text-red">{{ $t('add_issue') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="isTask(items.row) && isIssueResolver(items.row)"
                  @click="onRegisterTask(items.row, false, 4)"
                >
                  <span class="text-xs text-red">{{ $t('resolve_issue') }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  v-if="!items.row.completed && isTask(items.row) && withLockTypeCreator(items.row) && isLockAssignmentTask(items.row) == false"
                  @click="onRegisterTask(items.row, false, 3)"
                >
                  <span class="text-xs text-red">{{ $t('add_lock_type') }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table-column>
      </template>

        <template slot="detail" slot-scope="child">
          <!--Mediciones -->
          <div v-if="child.row.child && child.row.child.length > 0">
          <assignment-table :ref="'assignments_' + child.row.id" :list="child.row.child" :entityId="child.row.parentId"
                            :parentAssignmentId="child.row.id"
                            :entityBlockedAssignments="entityBlockedAssignments"
                            :apiProject="apiProject"
                            :canManageCertifiers="canManageCertifiers"
                            :canRecordActualprogress="canRecordActualprogress"
                            :currentStartDate="currentStartDate"
                            :currentEndDate="currentEndDate"
                            :lockedTasks="lockedTasks"
                            :canManage="canManage"
                            :subactivityId="subactivityId"
                            :activityName="activityName"
                            :activityId="activityId"
                            :deph="deph + 1"
                            :expanded-assignment-ids="expansionMap"
                            @reload="reload()"/>
          </div>
        </template>

    </b-table>

    <!-- Modal para Editar -->
    <assignment-update-modal
      ref="assignment_update_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="reload"
    />

    <task-update-modal
      ref="task_update_modal"
      entity-type="activity"
      :entity-id="entityId"
      :canManage="project && project.can_admin"
      @reload="reload"
    />

    <task-modal
      ref="task_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="reload"
    />

    <assignment-validate-quantity-modal
      ref="assignment_validate_quantity_modal"
      entity-type="activity"
      :entity-id="entityId"
    />

    <!-- Modal para crear recursos / subrecursos -->
    <assignment-modal
      ref="assignment_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="reload"
    />

    <!-- Modal para registrar progreso (normal o real) -->
    <assignment-contribute-drawing-modal
      ref="assignment_contribute_drawing_modal"
      entity-type="activity"
      :entity-id="entityId"
      :current-start-date="currentStartDate"
      :current-end-date="currentEndDate"
      @reload="reload"
    />

    <assignment-register-task-modal
      ref="assignment_register_task_modal"
      entity-type="activity"
      :entity-id="entityId"
      :activityId="activityId"
      :activityName="activityName"
      :subactivityId="subactivityId"
      @reload="reload"
    />

    <!-- modal para comentario a tarea -->
    <assignment-comment-task-modal
      ref="assignment_comment_task_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="reload"
    />

    <assignment-lines-traceability-modal
      ref="assignment_lines_traceability_modal"
      :entity-id="entityId"
      :can-record-actualprogress="canRecordActualprogress"
    />
  </div>
</template>

<script>

  import axios from 'axios'
  import assignmentUpdateModal from "·/components/assignment-update-modal";
  import assignmentModal from "·/components/assignment-modal";
  import taskUpdateModal from "·/components/task-update-modal";
  import taskModal from "·/components/task-modal";
  import EventBus from "~/plugins/bus";
  import {mapGetters} from "vuex";
  import { formatProjectFigure } from '·/helpers/quantity-display';
  import AssignmentValidateQuantityModal from '·/components/assignment-validate-quantity-modal';
  import assignmentRegisterTaskModal from "·/components/assignment-register-task-modal";
  import assignmentContributeDrawingModal from "·/components/assignments/assignment-contribute-drawing-modal.vue";
  import assignmentCommentTaskModal from "·/components/assignment-comment-task-modal";
  import assignmentLinesTraceabilityModal from "·/components/assignment-lines-traceability-modal";

  const lineStatus = {
    ISSUE: 20,
    ISSUE_SOLVED: 21,
    ISSUE_WITHOUT_LOCK: 22,
    ISSUE_LOCK_TASK: 23,
    ISSUE_LOCK_ACTIVITY: 24,
    ISSUE_LOCK_PROJECT: 25,
    ISSUE_LOCK_SOLVED: 26,
    ISSUE_RESOLVED: 27,
    ISSUE_LOCK_ACTIVITY_PARENT: 28,
    ISSUE_PENDIG: 30
  }

  /** Sobrevive al remount tras refresh por notificación (misma activity). */
  const expandedAssignmentsByActivity = Object.create(null)

  export default {
    name: "assignment-table",

    components: {
      assignmentUpdateModal,
      taskUpdateModal,
      AssignmentValidateQuantityModal,
      assignmentModal,
      taskModal,
      assignmentRegisterTaskModal,
      assignmentContributeDrawingModal,
      assignmentCommentTaskModal,
      assignmentLinesTraceabilityModal,
    },

    props: {
      list: Array,
      entityId: {type: Number, required: true},
      /** Si esta tabla representa hijos de una medición padre (subnivel) */
      parentAssignmentId: {type: Number, required: false, default: null},
      /** Contexto para redirecciones (issue/subissue create) */
      subactivityId: {type: Number, required: false, default: null},
      activityName: {type: String, required: false, default: null},
      /** activity_id requerido por rutas issue/subissue */
      activityId: {type: Number, required: false, default: null},
      entityBlockedAssignments: {type: Boolean, required: false, default: true},
      apiProject: { type: Object, required: false },
      deph: { type: Number, required: false, default: 0 },
      /** Igual que en activity-assignments: certificador puede editar con mediciones bloqueadas */
      canManageCertifiers: { type: Boolean, required: false, default: false },
      /** Permite registrar progreso real (equivale a canRecordActualprogress en activity-assignments) */
      canRecordActualprogress: { type: Boolean, required: false, default: false },
      /** Fechas necesarias por assignment-contribute-drawing-modal */
      currentStartDate: { type: String, required: false, default: '' },
      currentEndDate: { type: String, required: false, default: '' },
      /** Para bloquear edición/registro de tareas (misma lógica que assignment-task-table) */
      lockedTasks: { type: Boolean, required: false, default: false },
      /** Permiso para gestionar tareas (crear subtareas) */
      canManage: { type: Boolean, required: false, default: false },
      /** Mapa compartido { [assignmentId]: true } de filas detailed abiertas (árbol completo). */
      expandedAssignmentIds: { type: Object, required: false, default: null },
    },

    data: function() {
      const activityKey = this.entityId
      if (!expandedAssignmentsByActivity[activityKey]) {
        expandedAssignmentsByActivity[activityKey] = {}
      }
      return {
        loadingData: false,
        assignments: this.list,
        /** Hijos cargados por id (no se pierden al recomputar _list). */
        childrenByAssignmentId: {},
        localExpandedAssignmentIds: expandedAssignmentsByActivity[activityKey],
      }
    },

    computed: {

      ...mapGetters({
        user: 'auth/user',
        project: 'app/project',
        company: 'app/company',
      }),

      expansionMap() {
        return this.expandedAssignmentIds || this.localExpandedAssignmentIds
      },

      openedDetailedIds() {
        return (this._list || [])
          .filter((row) => this.expansionMap[row.id])
          .map((row) => row.id)
      },

      _list() {
        // Añdimos propiedad level si solo es chapter contiene la profundidad en la que se encuentra el nodo
        // luego sera usado para identar en la vista
        // tambien añadimos una propiedad code order para ordenar por el mismo y evitar que aparezca el siguiente orden 1, 10, 11, 2, 3
        // para ello en codeOrder añadimos un cero delante del numero si es menor a 10
        this.assignments.forEach(( item ) => {
          if( item.type === 'chapter' ) {
            let codes = item.code.split('.')
            item.level = codes.length - 1
            item.marginLeft = item.level * 5

            if( item.level > 1 )
              item.marginLeft += 5

            if( codes[0].length === 1 )
              item.sortCode = '0' + codes.join('.')
            else
              item.sortCode = codes.join('.')
          }
          if (this.childrenByAssignmentId[item.id]) {
            this.$set(item, 'child', this.childrenByAssignmentId[item.id])
          }
        })

        //primero ordenamos por tipo y luego ordenamos por codigo
        // TODO revisar y monitorear el comportamiento de momento funciona esta logica pero si hay otro tipo con un code puede fallar
        // buscar una manera para optimizar esta logica
        let orderList = this.assignments.sort((a, b) => { a.type.localeCompare(b.type) })
        // Aquí solo mandamos a ordenar los que son de tipo capítulo
        let listOrder = orderList.sort( function(a, b) {
          if( a.type === 'chapter' && b.type === 'chapter' ) {
            if (a.sortCode < b.sortCode) return -1;
            if (a.sortCode > b.sortCode) return 1;
          }

          return 0;
        });


        if ( this.deph == 0 ) {

          // procesamos la lista para crear la jerarquia
          const listData = listOrder
                  // Mapa auxiliar por id
            const map = {}
          listData.forEach(item => {
            map[item.id] = {
              ...item,
              child: this.childrenByAssignmentId[item.id] || item.child || [],
            }
          })

          const tree = []

          listData.forEach(item => {
            if (item.parent_assignment_id && map[item.parent_assignment_id]) {
              // Si tiene padre y existe en el mapa, lo agregamos como hijo
              map[item.parent_assignment_id].child.push(map[item.id])
            } else {
              // Si no tiene padre (o no existe el padre), es raíz
              tree.push(map[item.id])
            }
          })
          return tree
        }

        return listOrder
      },

      executedQuantityLabel() {
        let label = this.$t('executed_quantity');
        if (this.company.alias == 'welink') {
          label = this.$t('inspected_quantity');
        }
        return label;
      },

      pendingQuantityLabel() {
        let label = this.$t('pending_validation_quantity');
        if (this.company.alias == 'welink') {
          label = this.$t('pending_inspect');
        }
        return label;
      },

      registerProgressLabel() {
        let label = this.$t('register_progress');
        if (this.company.alias == 'welink') {
          label = this.$t('progress_to_inspect');
        }
        return label;
      },

      progressLabelShort() {
        let label = this.$t('progress_label');
        if (this.company.alias == 'welink') {
          label = this.$t('progress_inspected_label_short');
        }
        return label;
      },

    },

    watch: {},

    mounted() {
      this._onAssignmentChanged = (e) => {
        if (this.entityId === e.activity_id) {
          this.reloadFromNotification();
        }
      };
      this._onAssignmentCreated = (e) => {
        if (this.entityId === e.activity_id) {
          this.reloadFromNotification();
        }
      };
      this._onAssignmentDeleted = (e) => {
        if (this.entityId === e.activity_id) {
          this.reloadFromNotification();
        }
      };
      EventBus.$on("refreshAssignmentChangedNotifications", this._onAssignmentChanged);
      EventBus.$on("refreshAssignmentCreatedNotifications", this._onAssignmentCreated);
      EventBus.$on("refreshAssignmentDeletedNotifications", this._onAssignmentDeleted);

      // si profundidad es 0 cargamos las mediciones raíz; si es subnivel, recargamos solo ese subnivel
      // cuando aún no vienen en props (onDetailed del padre ya hace el GET y pasa :list).
      if (this.deph == 0) {
        this.loadAssignments(this.entityId);
      } else if (this.parentAssignmentId != null) {
        if (!Array.isArray(this.list) || this.list.length === 0) {
          this.loadAssignments(this.entityId, this.parentAssignmentId);
        } else {
          this.$nextTick(() => this.restoreExpandedBranches());
        }
      }
    },

    beforeDestroy(){
      if (this._onAssignmentChanged) {
        EventBus.$off("refreshAssignmentChangedNotifications", this._onAssignmentChanged);
      }
      if (this._onAssignmentCreated) {
        EventBus.$off("refreshAssignmentCreatedNotifications", this._onAssignmentCreated);
      }
      if (this._onAssignmentDeleted) {
        EventBus.$off("refreshAssignmentDeletedNotifications", this._onAssignmentDeleted);
      }
    },

    methods: {
      /**
       * Abre el modal para editar una medición
       */
      onClickEdit(row) {

        return; // deshabilitado modal para q no se pueda editar aqui

        if (!this.canOpenEditModal(row))
          return;

        this.entityId = row.parentId;
        this.$refs.assignment_update_modal.show(row.id);
      },

      onDetailed(row, index) {
        this.$set(this.expansionMap, row.id, true);
        this.loadAssignments(this.entityId, row.id, row);
      },

      onDetailsClose(row) {
        this.clearExpansionBranch(row);
      },

      clearExpansionBranch(row) {
        if (!row || !this.expansionMap[row.id]) {
          return;
        }
        const children = row.child || this.childrenByAssignmentId[row.id] || [];
        this.$delete(this.expansionMap, row.id);
        this.$delete(this.childrenByAssignmentId, row.id);
        children.forEach((child) => this.clearExpansionBranch(child));
      },

      // Modal para confirmar cantidades ejecutadas
      onClickValidate(row) {

        // User es usuario certificador del proyecto
        if (!this.apiProject.can_validate)
          return;

        this.entityId = row.parentId;
        this.$refs.assignment_validate_quantity_modal.show(row.id);
      },

      isTask(row) {
        if (row.type === 'task')
          return true;
      },

      isResource(row) {
        if (row.type === 'resource')
          return true;
      },

      reload(data) {
        // NO recargamos aquí: la recarga se controla por notificaciones (EventBus).
        // Así evitamos 2 peticiones (modal @reload + notificación).
      },

      reloadFromNotification() {
        this.$emit("reload");
        // Consolidar múltiples notificaciones seguidas en 1 petición
        const now = Date.now()
        if (now - this.lastReloadAtMs < 250) return

        if (this.reloadTimer) clearTimeout(this.reloadTimer)
        this.reloadTimer = setTimeout(() => {
          this.reloadTimer = null
          this.lastReloadAtMs = Date.now()

          if (this.deph == 0) {
            this.loadAssignments(this.entityId)
          } else if (this.parentAssignmentId != null) {
            this.loadAssignments(this.entityId, this.parentAssignmentId)
          }
        }, 50)
      },

      isCompleted(row, real = false) {
        if (row.completed && real == false){
          return '<i class="fas fa-check text-green"/>';
        } else if (row.completed == false && real == false) {
          return '<i  class="fas fa-times text-red"/>';
        }
        
        if (real && row.actual_progress >= 100) {
          return '<i class="fas fa-check text-green"/>';
        } else if (real && row.actual_progress < 100) {
          return '<i class="fas fa-times text-red"/>';
        }
      },

      /**
       * Cantidad o avance con los decimales del proyecto (2 o 4).
       */
      twoDecimals(number) {
        return formatProjectFigure(number == null ? 0 : number, this.project);
      },

      getStatusIcon(row) {
        switch (row.execution_status) {
          case 0:
            return 'fas fa-check text-green';
            break;
          case 1:
            return 'fas fa-chevron-up text-red';
            break;
          case -1:
            return 'fas fa-chevron-down text-blue';
            break;
        }
      },

      getSemaforoIcon(row) {
        return '<i class="' + this.getStatusIcon(row) + '"/>';
      },

      getStatusLabel(row) {
        switch (row.execution_status) {
          case 0:
            return 'assignment-completed';
            break;
          case 1:
            return 'assignment-over';
            break;
          case -1:
            return 'assignment-under';
            break;

        }
      },

      canOpenEditModal(row) {
        if (row.user_id != this.user.id && this.isTask(row)) return false;
        return true;
      },

      // Menú contextual por ahora solo para recursos y tareas (también si está completado).
      showAssignmentActionsMenu(row) {
        if (!row) return false
        return !!(this.isResource(row) || this.isTask(row))
      },

      // Si puede editar esta fila: recursos o tareas.
      canEditAssignment(row) {
        if (!row || row.completed) return false

        if (this.isResource(row)) {
          // misma regla que canEditAssignments() en activity-assignments 
          return this.canEditAssignmentsLock()
        }

        if (this.isTask(row)) {
          return this.project && this.project.can_admin && this.isLockAssignmentTask(row) == false
        }

        return false
      },

      // misma regla que canEditAssignments() en activity-assignments
      canEditAssignmentsLock() {
        return !this.entityBlockedAssignments || (this.entityBlockedAssignments && this.canManageCertifiers)
      },

      openTraceabilityModal(row) {
        if (!row || !this.$refs.assignment_lines_traceability_modal) return
        this.$refs.assignment_lines_traceability_modal.show(row)
      },

      /**
       * Abre el modal de edición según tipo de medición (desde menú contextual).
       */
      openEditAssignmentModal(row) {
        if (!row || row.completed || !this.canEditAssignment(row)) return

        if (this.isResource(row)) {
          const payload = {
            id: row.id,
            measure_unit_id: row.measure_unit_id,
          }
          if (row.measure_unit_id != null)
            payload.unit = { id: row.measure_unit_id }

          this.$refs.assignment_update_modal.show(payload)
        } else if (this.isTask(row)) {
          this.$refs.task_update_modal.show(row)
        }
      },

      // misma regla que assignment-task-table.vue
      // mismo mapa que assignment-task-table.vue: icono según issue_status del assignment
      getIssueIcon(assignment) {
        const statusMap = {
          [lineStatus.ISSUE]: { icon: 'exclamation-triangle', color: 'text-yellow' },
          [lineStatus.ISSUE_WITHOUT_LOCK]: { icon: 'exclamation-triangle', color: 'text-orange' },
          [lineStatus.ISSUE_LOCK_TASK]: { icon: 'exclamation-triangle', color: 'text-red' },
          [lineStatus.ISSUE_LOCK_ACTIVITY]: { icon: 'hand', color: 'text-orange' },
          [lineStatus.ISSUE_LOCK_ACTIVITY_PARENT]: { icon: 'hand', color: 'text-orange' },
          [lineStatus.ISSUE_LOCK_PROJECT]: { icon: 'hand', color: 'text-red' }
        }

        return statusMap[assignment.issue_status] || null
      },

      onCommentChanged(assignment) {
        this.$refs.assignment_comment_task_modal.show(assignment.id);
      },

      isLockAssignmentTask(assignment) {
        if (this.lockedTasks) return true
        return assignment && assignment.lines
          ? assignment.lines.some(line => line.status == lineStatus.ISSUE_LOCK_TASK)
          : false
      },

      openContributeDrawingModal(row, isActualProgress = false) {
        if (!row || row.completed) return
        if (!this.isResource(row)) return
        if (row.children_count != 0) return
        if (isActualProgress && !this.canRecordActualprogress) return
        this.$refs.assignment_contribute_drawing_modal.show(row.id, isActualProgress)
      },

      async addSubResource(row) {
        if (!row || row.completed) return
        if (!this.isResource(row)) return
        if (!this.canEditAssignmentsLock()) return
        if (row.lines != null) return

        let siblings = []
        if (row.children_count > 0) {
          const { data } = await axios.get('/api/v2/activity/' + this.entityId + '/assignments', {
            params: { parent_assignment_id: row.id }
          })
          if (data && data.success && data.data) {
            siblings = data.data
          }
        }

        this.$refs.assignment_modal.show(row, siblings)
      },

      onRegisterTask(assignment, isReal = false, actionType = 1) {
        this.$refs.assignment_register_task_modal.show(assignment, isReal, actionType)
      },

      // igual que assignment-task-table.vue (depende de `lines` en el assignment)
      isIssueResolver(assignment) {
        return assignment && assignment.lines
          ? assignment.lines.some(line => line.status == lineStatus.ISSUE)
          : false
      },

      // igual que assignment-task-table.vue (depende de `lines` en el assignment)
      withLockTypeCreator(task) {
        if (this.project && this.project.can_task_resolutor && this.company && this.company.configs && this.company.configs.subtasks) {
          return task && task.lines ? task.lines.some(line => line.status === lineStatus.ISSUE) : false
        }
        return false
      },

      withSubTasks() {
        return this.deph < 4 && this.company && this.company.configs && this.company.configs.subtasks
      },

      onCreateTaskSubTask(task) {
        this.$refs.task_modal.show(task)
      },

      loadAssignments(id, parentAssignmentId = null, row = null) {
        this.loadingData = true;
        let self = this;
        let url = '/api/v2/activity/' + id + '/assignments';
        return axios.get(url, {params: {
          ...(parentAssignmentId ? { parent_assignment_id: parentAssignmentId } : {})
        }})
        .then(function (response) {
          if (response.data && response.data.success) {
            const rows = response.data.data || [];
            if (row) {
              self.$set(self.childrenByAssignmentId, row.id, rows);
              self.$set(row, 'child', rows);
              self.loadingData = false;
              return;
            }
            self.assignments = rows;
          }
          self.loadingData = false;
          return self.$nextTick().then(() => self.restoreExpandedBranches());
        })
        .catch(function () {
          self.loadingData = false;
        })
      },

      /**
       * Reabre filas detailed marcadas en expansionMap y recarga sus hijos.
       */
      async restoreExpandedBranches() {
        const rows = this._list || [];
        const toRestore = rows.filter((row) => this.expansionMap[row.id]);
        if (!toRestore.length) {
          return;
        }

        await Promise.all(toRestore.map(async (row) => {
          try {
            const url = '/api/v2/activity/' + this.entityId + '/assignments';
            const { data } = await axios.get(url, {
              params: { parent_assignment_id: row.id },
            });
            if (data && data.success) {
              const children = data.data || [];
              this.$set(this.childrenByAssignmentId, row.id, children);
              this.$set(row, 'child', children);
            }
          } catch (e) {
            // silent
          }
        }));
      },

    }
  };
</script>

<style lang="scss">
  .line-level {
    display: inline-block;
    border-left: 2px solid #607eb9;
    border-bottom: 2px solid #607eb9;
    padding-bottom: 10px;
  }
  .measurements {
    .table th {
      background-color: #679dbf;
    }

    &.b-table .table.is-bordered th.is-current-sort, &.b-table .table.is-bordered th.is-sortable:hover {
      background-color: #679dbf !important;
    }

  }

  .clickable {
    cursor: pointer;
  }
</style>
